module.exports = __webpack_public_path__ + "static/media/girl-26.ebb67132.svg";